/**
 * Converte os parâmetros recebidos por "echartOption.legend.tooltip.formatter" em parâmetros do tipo
 * "echartOption.tooltip.formatter" para poder exibir a tooltip no gráfico ao passar o mouse sobre 
 * a legenda do gráfico de barras simples.
 * @param {array<object>} series Serie de dados plotados no gráfico de barras 
 * @param {array<string>} disabledLegends legendas atualmente desabilitadas no gráfico 
 * @param {Function} defaultFormatter Formatador padrão do gráfico de barras 
 */
export default function legendTooltipFormatter(series = [], disabledLegends = [], defaultFormatter) {
  return function(params) {
    if (disabledLegends.includes(params.name)) return;

    const serieIndex = series.findIndex(({ name }) => name === params.name);
    const dataIndex = series[serieIndex].data.findIndex(dataItem => !!dataItem);

    const value = series[serieIndex].data[dataIndex].value;
    const numeric = series[serieIndex].data[dataIndex].numeric;

    const fakeParams = {
      marker: '',
      data: {
        name: params.name,
        value,
        numeric,
      },
      name: params.name,
    };

    return defaultFormatter(fakeParams);
  }
}